import styled, { css } from 'styled-components';
import { regularWhite } from './design-tokens';
import { regularOutline } from './typography/helpers';

export const ClearFix = css`
    &:after {
        content: '';
        clear: both;
        display: table;
    }
`;

export const playFocus = (offset = 0, color = regularWhite) => css`
    outline: none;

    &:focus {
        ${regularOutline(offset, color)}
    }

    &:focus-visible {
        ${regularOutline(offset, color)}
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }
`;

export const VisuallyHidden = css`
    position: absolute !important; /* stylelint-disable-line declaration-no-important */
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    outline: 0;
`;

export const VisuallyHiddenStyle = styled.p`
    ${VisuallyHidden}
`;

export const ButtonNoStyle = styled.button`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    ${playFocus(2)}
`;
